<div class="row content_body-inner">
    <div class="col-md-3 left_nav bg-primary sticky" *ngIf="!hasRoute('clinic-submitted')">
        <app-left-nav *ngIf="!hideMob" [currentRoute]="this.currentRoute"></app-left-nav>
        <app-left-nav-img *ngIf="!hideMob"></app-left-nav-img>
        <app-mobile-top-bar></app-mobile-top-bar>
    </div>
    <div [ngClass]="hasRoute('clinic-submitted') ? 'col-md-12 mt-66' : 'col-md-9 mt-132'">
        <router-outlet></router-outlet>
    </div>
</div>